import $ from 'jquery';

import handleCalculations from './calculator/index';
import attachCompareBar from './compare-bar/index';
import attachRewardFilters from './reward-filters/index';
import attachFilters from './filters/index';
import initFeaturedFilters from './filters/frequent-flyer';
import initQueryFilters, { areRedirectionParamsDefined } from './filters/query-filters';
import attachExpander from './expander/index';
import loadMore from './load-more/index';
import attachPagination from './pagination/index';
import attachPaginationNav from './pagination-nav/index';
import tableQuiz from './table-quiz/index';
import tableModal from './modal/index';
import standAloneForm from './stand-alone-form/index';
import initInputFormatter from './calculator/input-autoformatter';

import {
  createTableSorting,
  registerEventListeners,
  initialize,
} from './table/index';
import './sidebar/index';
import './style.scss';
import './hero-cards/style.scss';
import './ccf-points/style.scss';
import './table/comparison-dops-test/style.scss';
import './table/full-market-comparison/style.scss';

const comparisonCalculatorSelector = '.js-comparison-calculator';
const comparisonTableSelector = '.js-calculator-table, .js-comparison-table';
const filtersSelector = '.js-form-widget--filter';
const showLessTextSelector = '.js-showLessText';
const showTitleLessTextSelector = '.js-showTitleLessText';
const MAX_CELL_LENGTH = 40;

function extendTable(i, table) {
  const $table = $(table);
  const $calculator = $table
    .parents(comparisonCalculatorSelector);
  const $tableFilters = $calculator
    .find(filtersSelector);
  const hasTableFilters = $tableFilters.length > 0;
  const hasQueryFilters = areRedirectionParamsDefined($calculator) && ($tableFilters.length > 0 || hasFilterTemplate);
  const hasLoadMore = $table.data('load-more-rows');
  const hasPagination = $table.data('pagination');
  const hasPaginationNav = $table.data('pagination-nav');
  const showLessText = $table.find(showLessTextSelector);
  const showTitleLessText = $table.find(showTitleLessTextSelector);

  if (showLessText.length > 0) {
    showLessText.each(function () {
      textExpander($(this), MAX_CELL_LENGTH);
    });
  }

  if (hasTableFilters) {
    attachFilters($tableFilters);
  }

  if (showTitleLessText) {
    attachTitleExpander($table);
    $(document).on('attach-title-expander', () => {
      attachTitleExpander($table);
    });
  }

  const $filterTemplate = $('#filter-form-frequent-flyers-template');
  const $noResultsTemplate = $('#no-results-frequent-flyers-template');
  const hasFilterTemplate = $filterTemplate.length > 0;

  if (hasFilterTemplate) {
    initFeaturedFilters({
      source: $filterTemplate.html(),
      noResults: $noResultsTemplate.html(),
      $calculator,
      $table,
    });
  }

  if (hasLoadMore) {
    loadMore($table);
  }

  if (hasPagination) {
    attachPagination($table);
  }

  if (hasPaginationNav && $calculator.length) {
    attachPaginationNav(table, $calculator[0]);
  }

  handleCalculations($calculator, $table);
  createTableSorting($table);
  attachCompareBar(table);
  attachExpander(table);

  const $rewardsFilterTemplate = $calculator.find('#filterFormLunaFrequentFlyerTemplate');
  const hasRewardFilters = $rewardsFilterTemplate.length > 0;
  if (hasRewardFilters) {
    attachRewardFilters({
      source: $rewardsFilterTemplate.html(),
      $calculator,
      $table,
    });
  }

  initialize($table);

  if (hasQueryFilters) {
    initQueryFilters($calculator);
  }

  function textExpander(cell, maxLength) {
    const cellTextLength = cell.text().length;
    const shouldTruncate = cellTextLength > maxLength;

    if (shouldTruncate) {
      createTextExpander(cell, maxLength);
      setProductCellHeight(cell);
    }
  }

  function createTextExpander(cell, length) {
    const $truncSpan = $('<span></span>')
      .addClass('truncated')
      .text(truncateText(cell.text(), length));

    const $fullSpan = $('<span></span>')
      .addClass('full')
      .text(cell.text())
      .css('display', 'none');

    const $expandLink = $('<a></a>')
      .text('more')
      .attr('href', '#')
      .on('click', handleExpandText);

    return cell.text('').append($truncSpan).append($fullSpan).append($expandLink);
  }

  function truncateText(cellText, length) {
    return `${cellText.slice(0, length)}... `;
  }

  function handleExpandText(event) {
    event.preventDefault();
    const $moreBtn = $(this);
    const $cell = $moreBtn.closest('td');

    $moreBtn.css('display', 'none')
      .siblings('.full')
      .css('display', 'block')
      .siblings('.truncated')
      .css('display', 'none');
    setProductCellHeight($cell);
  }

  function setProductCellHeight(cell) {
    const $cell = cell.siblings('.comparison-table__product');
    const $parent = $cell.parent();
    if ($parent.height()) {
      const currentHeight = `${$parent.height()}px`;
      $cell.css('height', currentHeight);
    }
  }
}

function showCompareButton($compareDiv) {
  return $compareDiv.show();
}

function hideCompareButton($compareDiv) {
  return $compareDiv.hide();
}

function attachTitleExpander($table) {
  const showTitleLessText = $table.find(showTitleLessTextSelector);
  if (showTitleLessText.length > 0) {
    showTitleLessText.each(function () {
      textTitleExpander($(this));
    });
  }

  function getArrowIcon(type) {
    const $svg = $('<svg viewBox="0 0 24 24"></svg>');

    if (type === 'down') {
      $svg.html(`
        <path d="M7.41,8.59L12,13.17l4.59-4.58L18,10l-6,6l-6-6L7.41,8.59z"/>
        <path fill="none" d="M0,0h24v24H0V0z"/>
      `);
    } else if (type === 'up') {
      $svg.html(`
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      `);
    }

    return $('<div>')
      .addClass('icon iconSmall')
      .append($svg);
  }

  function textTitleExpander(cell) {
    const MAX_TITLE_LENGTH = 90;
    const cellTextLength = cell.text().length;
    const shouldTruncate = cellTextLength > MAX_TITLE_LENGTH;
    const $parent = cell.parent();
    const $expandLink = $('<a></a>')
      .append(getArrowIcon('down'))
      .attr('href', '#')
      .addClass('expandLink js-expandLink')
      .on('click', handleTitleExpandText);

    return shouldTruncate ? $parent.append($expandLink) : '';
  }

  function handleTitleExpandText(event) {
    event.preventDefault();
    const $moreBtn = $(event.currentTarget);
    const $row = $moreBtn.closest('tr');
    const $compareDiv = $row.find('.comparison-table__compare');
    const $nameDiv = $row.find('.js-comparison-table__mobileName');
    const $expandLink = $row.find('.js-expandLink');
    const hasMobileNameClass = $nameDiv.hasClass('comparison-table__mobileName');

    if (hasMobileNameClass) {
      $expandLink.html(getArrowIcon('up'));
      $nameDiv.removeClass('comparison-table__mobileName');
      showCompareButton($compareDiv);
    } else {
      $expandLink.html(getArrowIcon('down'));
      $nameDiv.addClass('comparison-table__mobileName');
      hideCompareButton($compareDiv);
    }
  }
}

// Table Quiz is used on the US site to help improve quality of leads
tableQuiz('.js-table-quiz');
// Table Modal
tableModal('.js-table-modal');
// Display table after Stand alone "Calculator" / "Filter" form submit
standAloneForm('.js-stand-alone-table-form');

registerEventListeners();

// Is not always defined - TODO: find out why. See https://finder.atlassian.net/browse/AUD-1942
if (typeof monitorCTAClicks !== 'undefined') {
  monitorCTAClicks();
}

const initializeTable = (table = comparisonTableSelector) => $(table).each(extendTable);
window._templateTable_initializeTable = initializeTable; // Uses in fhl-wizard
initializeTable();

initInputFormatter();

$(document).on('full-table-redraw', (e, targetPlaceholder) => {
  let table;
  let formFields;
  let tableSorter = 'table.js-tablesorter';

  if (targetPlaceholder) {
    table = `${targetPlaceholder} ${comparisonTableSelector}`;
    tableSorter = `${table}.js-tablesorter`;
    formFields = `${targetPlaceholder} input[type="text"][data-autoformat]`;
  }

  // Initalize new table
  initializeTable(table);
  initInputFormatter(formFields);
  window.vendorUtils.importTablesorter().then(() => {
    $(tableSorter).tablesorter();
  });
});
